export default "__VITE_ASSET__d6ff9e3f__"